import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "./ui/alert-dialog";

export const DeletePlayDialog = ({ open, onOpenChange, playName, onConfirm, busy }) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent data-testid="delete-play-dialog">
      <AlertDialogHeader>
        <AlertDialogTitle>Delete “{playName || "this play"}”?</AlertDialogTitle>
        <AlertDialogDescription>This removes the play for every coach on the team. It cannot be undone.</AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel data-testid="delete-play-cancel">Keep it</AlertDialogCancel>
        <AlertDialogAction data-testid="delete-play-confirm" onClick={onConfirm} disabled={busy} className="bg-destructive text-destructive-foreground hover:bg-destructive/90">{busy ? "Deleting…" : "Delete play"}</AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
